<template>
    <div class="exportModalOverlay" @click.self="handleClose">
        <div class="exportModal">
            <h3 class="exportModalTitle">Export Options</h3>

            <label class="exportOption">
                <input type="checkbox" v-model="includeCustomItems" />
                <span>Include Custom Items</span>
            </label>

            <label class="exportOption">
                <input type="checkbox" v-model="includeServiceItems" />
                <span>Include Service Items</span>
            </label>

            <div class="exportModalActions">
                <button type="button" class="btn-round-red" @click="handleClose">
                    Cancel
                </button>
                <button type="button" class="btn-round-green" @click="handleConfirm">
                    Export
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        showExportModal: {
            type: Boolean,
            default: false
        },
        ppId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            includeCustomItems: false,
            includeServiceItems: false,
        };
    },
    watch: {
        showExportModal(newVal) {
            if (newVal) {
                this.resetOptions();
            }
        }
    },
    methods: {
        resetOptions() {
            this.includeCustomItems = false;
            this.includeServiceItems = false;
        },
        handleClose() {
            this.resetOptions();
            this.$emit('close');
        },
        handleConfirm() {
            this.$emit('confirm', {
                ppId: this.ppId,
                includeCustomItems: this.includeCustomItems,
                includeServiceItems: this.includeServiceItems,
            });

            this.resetOptions();
        }
    }
}
</script>

<style scoped>
    .exportModalOverlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        padding: 20px;
    }

    .exportModal {
        background: #fff;
        padding: 24px;
        border-radius: 8px;
        width: 100%;
        max-width: 420px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    }

    .exportModalTitle {
        margin: 0 0 10px;
    }

    .exportModalText {
        margin: 0 0 16px;
        color: #555;
        line-height: 1.4;
    }

    .exportOption {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 12px 0;
        cursor: pointer;
    }

    .exportOption input[type="checkbox"] {
        margin: 0;
    }

    .exportModalActions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 20px;
        flex-wrap: wrap;
    }

    .exportModalActions button {
        min-width: 110px;
        margin-top: 0;
    }
</style>